import * as THREE from "three";

export class SectorGrid {
  readonly group = new THREE.Group();
  private readonly material = new THREE.LineBasicMaterial({ color: "#2b6d96", transparent: true, opacity: 0.28 });

  constructor(sectorSize: number, radius = 2) {
    const points: number[] = [];
    const extent = sectorSize * radius;
    for (let i = -radius; i <= radius; i += 1) {
      const value = i * sectorSize;
      points.push(-extent, 0, value, extent, 0, value);
      points.push(value, 0, -extent, value, 0, extent);
    }
    for (let y = -1; y <= 1; y += 1) {
      const height = y * sectorSize;
      points.push(-extent, height, 0, extent, height, 0);
      points.push(0, height, -extent, 0, height, extent);
    }
    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute("position", new THREE.Float32BufferAttribute(points, 3));
    const lines = new THREE.LineSegments(geometry, this.material);
    lines.frustumCulled = false;
    this.group.add(lines);

    const axisMaterialX = new THREE.LineBasicMaterial({ color: "#e55656", transparent: true, opacity: 0.75 });
    const axisMaterialY = new THREE.LineBasicMaterial({ color: "#6dda7b", transparent: true, opacity: 0.75 });
    const axisMaterialZ = new THREE.LineBasicMaterial({ color: "#5fa8ff", transparent: true, opacity: 0.75 });
    this.group.add(
      new THREE.Line(new THREE.BufferGeometry().setFromPoints([new THREE.Vector3(-extent, 0, 0), new THREE.Vector3(extent, 0, 0)]), axisMaterialX),
      new THREE.Line(new THREE.BufferGeometry().setFromPoints([new THREE.Vector3(0, -extent, 0), new THREE.Vector3(0, extent, 0)]), axisMaterialY),
      new THREE.Line(new THREE.BufferGeometry().setFromPoints([new THREE.Vector3(0, 0, -extent), new THREE.Vector3(0, 0, extent)]), axisMaterialZ),
    );
    this.group.name = "interplanetary-sector-grid";
  }

  setVisible(visible: boolean): void {
    this.group.visible = visible;
  }
}
